import { getConfig } from "@src/config";
import { Maybe } from "@src/graphql.apollo.generated";
import { getCurrencySignFromDomain } from "@src/skeleton/intlProvider/CustomIntlProvider";
import * as React from "react";
import { FormattedMessage, FormattedNumber, IntlShape } from "react-intl";

interface FormattedCurrencyProps {
    maximumFractionDigits?: number;
    minimumFractionDigits?: number;
    value?: Maybe<number>;
}

interface FormattedCurrencyTextProps extends FormattedCurrencyProps {
    intl: IntlShape;
}

export const formattedCurrencyText = ({ maximumFractionDigits = 0, minimumFractionDigits, value, intl }: FormattedCurrencyTextProps): string => {
    const domain = getConfig("scope").domain;
    const isCar4meHU = domain === "car4me.porschefinance.hu";
    const currencySign = getCurrencySignFromDomain(domain);

    return intl.formatMessage(
        {
            id: "leaseme.priceInfo.currencyText",
            defaultMessage: "{domain, select, true{{price} {currencySign}} other{{currencySign} {price}}}",
        },
        {
            domain: isCar4meHU,
            price: value
                ? intl.formatNumber(value, {
                      maximumFractionDigits,
                      minimumFractionDigits,
                  })
                : "-",
            currencySign,
        },
    );
};

const FormattedCurrency: React.FC<FormattedCurrencyProps> = ({ maximumFractionDigits = 0, minimumFractionDigits, value }) => {
    const domain = getConfig("scope").domain;
    const isCar4meHU = domain === "car4me.porschefinance.hu";
    const currencySign = getCurrencySignFromDomain(domain);

    return (
        <>
            <FormattedMessage
                id="leaseme.priceInfo.currencyText"
                defaultMessage="{domain, select, true{{price} {currencySign}} other{{currencySign} {price}}}"
                values={{
                    domain: isCar4meHU,
                    price: value ? (
                        <FormattedNumber value={value} maximumFractionDigits={maximumFractionDigits} minimumFractionDigits={minimumFractionDigits} />
                    ) : (
                        "-"
                    ),
                    currencySign,
                }}
            />
        </>
    );
};

export default FormattedCurrency;
